export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/4edc88cf656e7c8c099b3d1dd0e75669.jpeg"
          alt="Elegant Event"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full">
        <div className="inline-block mb-6 px-6 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <span className="text-white text-sm font-semibold tracking-wide">PREMIUM EVENT SERVICES</span>
        </div>
        
        <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-white font-normal mb-6 leading-tight">
          Simply Elegant
        </h1>
        
        <p className="text-white/90 text-lg md:text-xl lg:text-2xl mb-10 max-w-3xl mx-auto leading-relaxed">
          Professional waiters, premium catering and elegant decoration for your most special events
        </p>

        <div className="flex flex-wrap gap-4 justify-center">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D4AF37] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#C5A028] transition-all transform hover:scale-105 inline-flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-2xl"
          >
            Request a Quote
            <i className="ri-arrow-right-line"></i>
          </button>
          <button 
            onClick={() => {
              const element = document.getElementById('services');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold text-lg border-2 border-white/30 hover:bg-white hover:text-[#D4AF37] transition-all whitespace-nowrap cursor-pointer"
          >
            Our Services
          </button>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <i className="ri-trophy-line text-5xl text-[#D4AF37] mb-3"></i>
            <div className="text-3xl font-bold text-white mb-2">500+</div>
            <div className="text-white/80">Successful Events</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <i className="ri-team-line text-5xl text-[#D4AF37] mb-3"></i>
            <div className="text-3xl font-bold text-white mb-2">50+</div>
            <div className="text-white/80">Professionals</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <i className="ri-star-line text-5xl text-[#D4AF37] mb-3"></i>
            <div className="text-3xl font-bold text-white mb-2">10+</div>
            <div className="text-white/80">Years Experience</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
